<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import GroupSectionRequest from 'Modules/contacard/produto/groups/group-section/GroupSectionRequest';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';

export default {
  name: 'GroupSectionList',
  extends: CrudListVue,
  data: () => ({
    requestClass: GroupSectionRequest,
    hideEdit: true,
    headers: [
      {
        text: 'Seção',
        value: 'nomSecao',
      },
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Data da criação',
        value: 'createdDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  computed: {
    getGroupId() {
      return this.$route.params.groupId;
    },
  },
  methods: {
    makeRestDelete(row) {
      return this.requestClass.remove(this.getGroupId, row.id);
    },
    prepareRequest(params) {
      return this.requestClass
        .list(this.getGroupId, params);
    },
  },
};
</script>
